import { type OrgChartOut, orgChartOutSchema } from '@lms/shared-types'
import { apiRequest } from './client'

/**
 * HR org chart — fetches the full assignment graph for the read-only
 * /hr/org-chart page (Track B MVP). HR / Director / Exec Director only;
 * a 403 from the API surface bubbles up as `ApiError`.
 *
 * Validated through the shared Zod schema so the FE fails loudly if the
 * wire shape drifts from the pydantic mirror.
 */
export async function getOrgChart(signal?: AbortSignal): Promise<OrgChartOut> {
  const raw = await apiRequest<OrgChartOut>(
    '/api/v1/hr/org-chart',
    signal ? { signal } : {},
  )
  return orgChartOutSchema.parse(raw)
}
